import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconLogin = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13H10.5858L8.95956 14.6262C8.56904 15.0168 8.56904 15.6499 8.95956 16.0404C9.35008 16.431 9.98325 16.431 10.3738 16.0404L13.7071 12.7071C14.0976 12.3166 14.0976 11.6834 13.7071 11.2929L10.3738 7.95956C9.98325 7.56904 9.35008 7.56904 8.95956 7.95956C8.56904 8.35008 8.56904 8.98325 8.95956 9.37377L10.5858 11H5ZM12 18C12 17.4477 12.4477 17 13 17H15.6667C15.8508 17 16 16.8508 16 16.6667V7.33333C16 7.14924 15.8508 7 15.6667 7H13C12.4477 7 12 6.55229 12 6C12 5.44771 12.4477 5 13 5H15.6667C16.9553 5 18 6.04467 18 7.33333V16.6667C18 17.9553 16.9553 19 15.6667 19H13C12.4477 19 12 18.5523 12 18Z"
        />
      </svg>
    );
  }
);
